var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 138,
    viewBox: "0 0 80 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.9211 1.5H65.0733V85.6963V87.1963H66.5733H78.3539V104.3H66.5733H65.0733V105.8V136.5H43.385V105.8V104.3H41.885H1.5V85.4885L36.9211 1.5ZM19.361 85.1879L18.6375 87.1963H20.7722H41.885H43.385V85.6963V27.0889L40.4738 26.5805L19.361 85.1879Z",
    stroke: "#767676",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.b93310f08249461327e517faf2f3338b.svg";
export { ForwardRef as ReactComponent };